import { defaultOptions, API_URL } from "./fetchOptions";
import { V1Res, User } from "./interfaces";
import * as V1Types from "./types/user";

export const logInUser = (
  args: V1Types.Login
): Promise<V1Res<V1Types.LoginRequestResult>> => {
  const requestOptions = defaultOptions({
    options: { method: "POST", body: JSON.stringify(args) },
  });

  return fetch(`${API_URL}/v1/auth/login`, requestOptions).then((res) =>
    res.json()
  );
};

export const oauthLogin = (args: V1Types.OAuthLogin): Promise<V1Res<V1Types.OAuthLoginResponse>> => {
  const requestOptions = defaultOptions({
    options: { method: "POST", body: JSON.stringify(args) },
  });

  return fetch(`${API_URL}/v1/auth/oauth/login`, requestOptions).then((res) =>
    res.json()
  );
};

export const updateUserRole = (
  args: V1Types.UpdateUserRole
): Promise<V1Res<User>> => {
  const requestOptions = defaultOptions({
    options: { method: "PUT", body: JSON.stringify({ role: args.role }) },
  });

  return fetch(`${API_URL}/v1/users/${args.user_id}/role`, requestOptions).then(
    (res) => res.json()
  );
};

export const fetchCurrentUser = (): Promise<V1Res<User>> => {
  return fetch(`${API_URL}/v1/users`, defaultOptions()).then((res) =>
    res.json()
  );
};

export const getAllUsers = (): Promise<V1Res<V1Types.UsersRequestResult>> => {
  return fetch(`${API_URL}/v1/users/all`, defaultOptions()).then((res) =>
    res.json()
  );
};

export const refreshSession = (
  args: V1Types.RefreshToken
): Promise<V1Res<V1Types.RefreshTokenRequestResult>> => {
  const requestOptions = defaultOptions({
    options: { method: "POST", body: JSON.stringify(args) },
  });

  return fetch(`${API_URL}/v1/auth/refresh_token`, requestOptions).then((res) =>
    res.json()
  );
};
